export default "__VITE_ASSET__ae81e9eb__"